import getSteelCategoryName from '../../getSteelMakerName';
import type { Language, ProcessCellCallbackParams, SelectOption, SteelCategory } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

const steelCategoryCellCallback = (params: ProcessCellCallbackParams): string => {
  const value: SteelCategory | SteelCategory[] = params.value;
  const steelCategoryCodes: SteelCategory[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const steelCategory: OptionsType<SteelCategory>[] | undefined = params.context?.steelCategory;
  // 分類コードの配列を分類名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const steelCategoryNames: string[] = steelCategoryCodes.map((code) => {
    const steelCategoryName: string = getSteelCategoryName(code, steelCategory, currentLang.value);
    return steelCategoryName;
  });
  const filterValue: string = steelCategoryNames.join(', ');
  return filterValue;
};

export default steelCategoryCellCallback;
